<div *ngIf="input.clearButton && hasAnyValue() && !input.control.disabled" class="clear-button-container">
    <button type="button" mat-icon-button (click)="clearValue()"
            [matTooltip]="'Click to clear ' + input.label"
            aria-label="Click to clear this value">
        <mat-icon
                color="warn"
                class="material-icons-outlined">cancel</mat-icon></button>
</div>
<app-multiple-select-output
        *ngIf="input.isMultiple && input.selectedValuesAsInfo"
        [asInfo]="input.selectedValuesAsInfo"
        [control]="input.control"
        [selectItems]="options"></app-multiple-select-output>
<mat-form-field
        [hidden]="(input.hideIfNoOptions === true && options?.length === 0)"
        [ngClass]="wrapperClasses"
        [appearance]="input.appearance"
        [floatLabel]="input.floatLabel"
        class="full-width">
    <mat-label>{{input.label}}</mat-label>
    <mat-select
            #select
            class="small-placeholder"
            [required]="input.required"
            [multiple]="input.isMultiple"
            [placeholder]="(input.placeholder ? input.placeholder : input.isMultiple ? 'Select one or more...' : 'Select one...')"
            [formControl]="input.control"
            [aria-labelledby]="select.id + editPromptSuffix"
            (selectionChange)="selectChange($event)"
            (blur)="blurEvent($event)"
            (focus)="focusEvent($event)">
            <mat-option *ngFor="let option of options" [value]="option.value">{{option.text}}</mat-option>
    </mat-select>
    <div class="loading-text" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" color="primary" diameter="20"></mat-progress-spinner>
        Loading...
    </div>
    <div class="loading-text text-error" *ngIf="errorLoading">Error loading options!<span *ngIf="notAuthorized"> Not Authorized</span></div>
    <mat-error>{{errorMessage}}</mat-error>
    <mat-hint [ngClass]="hint?.class">{{hint?.message}}</mat-hint>
</mat-form-field>
<app-multiple-select-output
        *ngIf="input.isMultiple && !input.selectedValuesAsInfo"
        [control]="input.control"
        [selectItems]="options"></app-multiple-select-output>